// Stable provider keys for the first-party Lender Integrations provider registry
// (Lender.Optimus.Integrations `IProviderDescriptor.Key` — e.g. `LobProviderDescriptor.ProviderKey`).
export const IntegrationProviderKey = {
  LOB: 'lob',
  LEGACY_SFTP: 'legacy-sftp',
  SNAPDOCS: 'snapdocs',
};
